import { render, staticRenderFns } from "./formBuilder.vue?vue&type=template&id=e98f4bba&scoped=true&"
import script from "./formBuilder.vue?vue&type=script&lang=js&"
export * from "./formBuilder.vue?vue&type=script&lang=js&"
import style0 from "./formBuilder.vue?vue&type=style&index=0&id=e98f4bba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98f4bba",
  null
  
)

component.options.__file = "formBuilder.vue"
export default component.exports